













































import Vue from "vue";
import Component from "vue-class-component";
import { Service as ServiceInterface } from "../../services/service/entities/service.interface";
import constants from "../../config/constants";

@Component
export default class HomeServices extends Vue {
  private created(): void {
    this.$store.dispatch("service/getServicesToClient", {
      start: 0,
      quantity: constants.ITEMS_PER_PAGE_CLIENT,
    });
  }

  private get services(): Array<ServiceInterface> {
    const services = this.$store.getters["service/getServices"];

    const result = services.filter(
      (service: ServiceInterface) =>
        service.serviceStatus == constants.STATUS.ACTIVE
    );

    let count = 1;
    const limitedResult = [];
    for (let index = 0; index < result.length; index++) {
      if (count <= 6) {
        limitedResult.push(result[index]);
        count++;
      }
    }

    return limitedResult;
  }
  onClick() {
    this.$router.push("/services/1");
  }
}
